import React from 'react';

import PropTypes from 'prop-types';

import { Card, TableMobile } from '@shared/components';

import styles from './AdvancementReportList.less';
import AdvancementReportListHeader from './AdvancementReportListHeader';
import advancementReportRows from './advancementReportRows';

function AdvancementReportList({
  items,
  loading,
  showPrice,
  onEdit,
  onAwardAdvancement,
  orgIsPack = false,
}) {
  return (
    <Card className={styles.mainCardWrapper} noPadding shadow>
      <AdvancementReportListHeader onEdit={onEdit} />
      <Card className={styles.cardListContainer} noPadding loading={loading}>
        <TableMobile
          loading={loading}
          items={items}
          rowId="key"
          rows={advancementReportRows(showPrice, orgIsPack, onAwardAdvancement)}
          itemsClassName={styles.records}
          onAwardAdvancement={onAwardAdvancement}
        />
      </Card>
    </Card>
  );
}

AdvancementReportList.propTypes = {
  loading: PropTypes.bool.isRequired,
  showPrice: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onAwardAdvancement: PropTypes.func.isRequired,
  orgIsPack: PropTypes.bool,
};

export default AdvancementReportList;
